export default __webpack_public_path__ + "static/media/logout.853198d1.png";